import { RootState } from '../../../app/store';

export const selectDate = (state: RootState) => {
  return state.incidents.date;
};
